import React, { useState } from 'react';
import { 
  ShieldCheck, AlertTriangle, Scale, Leaf, QrCode, Upload, Search, 
  ArrowRight, CheckCircle2, XCircle, Clock, Building2, UserCheck, 
  FileText, Database, TrendingUp, BarChart3, Filter, Plus, Eye, 
  Download, RefreshCw, Layers, Check, ChevronRight, Menu, X, HelpCircle,
  Award, DollarSign, MapPin, Sparkles, AlertCircle
} from 'lucide-react';
import { 
  QrCode as PhosphorQr, Scales, Recycle, Building, User, ChartLineUp,
  WarningCircle, CheckCircle, FilePdf, MagnifyingGlass
} from '@phosphor-icons/react';
import { QRCodeSVG } from 'qrcode.react';
import { Toaster, toast } from 'sonner';
import confetti from 'canvas-confetti';

// --- SEED MOCK DATA ---
const INITIAL_COLLECTIONS = [
  { id: 'COL-9821', pickerName: 'Laxmi Pawar', village: 'Dharavi, Mumbai', weight: 42.5, plasticType: 'HDPE / Bottles', date: '2026-07-12', status: 'Verified', earnings: 680, recycler: 'EcoPlast Maharashtra Ltd' },
  { id: 'COL-9820', pickerName: 'Santosh Shinde', village: 'Pune Rural, MH', weight: 110.0, plasticType: 'LDPE Films', date: '2026-07-12', status: 'Verified', earnings: 1760, recycler: 'GreenCycle Industries' },
  { id: 'COL-9819', pickerName: 'Sunita Kamble', village: 'Thane Urban, MH', weight: 28.3, plasticType: 'PET Bottles', date: '2026-07-11', status: 'Verified', earnings: 452, recycler: 'EcoPlast Maharashtra Ltd' },
  { id: 'COL-9818', pickerName: 'Ramesh Jadhav', village: 'Nagpur East, MH', weight: 85.0, plasticType: 'Mixed Rigid', date: '2026-07-11', status: 'Verified', earnings: 1360, recycler: 'Vidarbha Polymers' },
  { id: 'COL-9817', pickerName: 'Kanta More', village: 'Nashik Road, MH', weight: 65.2, plasticType: 'PP Caps & Cups', date: '2026-07-10', status: 'Verified', earnings: 1043, recycler: 'Godavari Recyclers' },
  { id: 'COL-9816', pickerName: 'Anil Rathod', village: 'Aurangabad, MH', weight: 150.0, plasticType: 'HDPE Drums', date: '2026-07-10', status: 'Verified', earnings: 2400, recycler: 'GreenCycle Industries' },
  { id: 'COL-9815', pickerName: 'Geeta Waghmare', village: 'Solapur, MH', weight: 34.0, plasticType: 'PET Bottles', date: '2026-07-09', status: 'Verified', earnings: 544, recycler: 'Solapur Green Processors' },
  { id: 'COL-9814', pickerName: 'Vijay Gaikwad', village: 'Kolhapur, MH', weight: 95.5, plasticType: 'LDPE Films', date: '2026-07-09', status: 'Verified', earnings: 1528, recycler: 'EcoPlast Maharashtra Ltd' },
  { id: 'COL-9813', pickerName: 'Laxmi Pawar', village: 'Dharavi, Mumbai', weight: 51.0, plasticType: 'HDPE / Bottles', date: '2026-07-08', status: 'Verified', earnings: 816, recycler: 'EcoPlast Maharashtra Ltd' },
  { id: 'COL-9812', pickerName: 'Santosh Shinde', village: 'Pune Rural, MH', weight: 78.0, plasticType: 'PET Bottles', date: '2026-07-08', status: 'Verified', earnings: 1248, recycler: 'GreenCycle Industries' },
  { id: 'COL-9811', pickerName: 'Sunita Kamble', village: 'Thane Urban, MH', weight: 62.0, plasticType: 'PP Caps & Cups', date: '2026-07-07', status: 'Verified', earnings: 992, recycler: 'EcoPlast Maharashtra Ltd' },
  { id: 'COL-9810', pickerName: 'Ramesh Jadhav', village: 'Nagpur East, MH', weight: 120.0, plasticType: 'HDPE Drums', date: '2026-07-07', status: 'Verified', earnings: 1920, recycler: 'Vidarbha Polymers' },
  { id: 'COL-9809', pickerName: 'Kanta More', village: 'Nashik Road, MH', weight: 45.0, plasticType: 'PET Bottles', date: '2026-07-06', status: 'Verified', earnings: 720, recycler: 'Godavari Recyclers' },
  { id: 'COL-9808', pickerName: 'Anil Rathod', village: 'Aurangabad, MH', weight: 88.0, plasticType: 'LDPE Films', date: '2026-07-06', status: 'Verified', earnings: 1408, recycler: 'GreenCycle Industries' },
  { id: 'COL-9807', pickerName: 'Geeta Waghmare', village: 'Solapur, MH', weight: 39.5, plasticType: 'Mixed Rigid', date: '2026-07-05', status: 'Verified', earnings: 632, recycler: 'Solapur Green Processors' },
  { id: 'COL-9806', pickerName: 'Vijay Gaikwad', village: 'Kolhapur, MH', weight: 105.0, plasticType: 'HDPE / Bottles', date: '2026-07-05', status: 'Verified', earnings: 1680, recycler: 'EcoPlast Maharashtra Ltd' },
];

// --- BRAND & CONTEXT ASSETS ---
const LOGO_URL = 'https://customer-assets-agu9un31.emergentagent.net/job_recycl-check/artifacts/wwhioohz_4d126d98-bbc1-454e-8c0f-41969e6e14f1.webp';
const PICKER_PHOTO_HERO = 'https://customer-assets-agu9un31.emergentagent.net/job_recycl-check/artifacts/2c0i7rbp_6680afc181ff86.27841485.webp';
const PICKER_PHOTO_REALITY = 'https://customer-assets-agu9un31.emergentagent.net/job_recycl-check/artifacts/3tpicp7x_images.jpg';

const INITIAL_CERTIFICATES = [
  { 
    id: 'CERT-501', 
    recyclerName: 'EcoPlast Maharashtra Ltd', 
    brandClient: 'Hindustan Unilever (Consumer Goods)', 
    claimedTonnage: 450, // tonnes
    verifiedTonnage: 432.8, 
    status: 'Verified', 
    date: '2026-07-10', 
    invoiceNo: 'EPL/2026/782',
    discrepancy: '-3.8%',
    note: 'Matched against 10,180 verified collection IDs in Thane & Mumbai.'
  },
  { 
    id: 'CERT-502', 
    recyclerName: 'Shakti Polymers & Recycling', 
    brandClient: 'Pepsico India Holdings', 
    claimedTonnage: 2800, 
    verifiedTonnage: 210, 
    status: 'Fraud Risk / Under-Collected', 
    date: '2026-07-08', 
    invoiceNo: 'SPL/INV/9941',
    discrepancy: '-92.5%',
    note: 'FLAGGED BY AI: Recycler capacity exceeds verified collections by 1,330%. Potential CPCB penalty invoked.'
  },
  { 
    id: 'CERT-503', 
    recyclerName: 'GreenCycle Industries', 
    brandClient: 'Nestlé India Ltd', 
    claimedTonnage: 1200, 
    verifiedTonnage: 1185.0, 
    status: 'Verified', 
    date: '2026-07-09', 
    invoiceNo: 'GCI-T-4402',
    discrepancy: '-1.25%',
    note: 'Robust matching with Pune & Aurangabad collection partner network.'
  },
  { 
    id: 'CERT-504', 
    recyclerName: 'Technova Recycling India', 
    brandClient: 'ITC Limited Packaging', 
    claimedTonnage: 5000, 
    verifiedTonnage: 340.0, 
    status: 'Fraud Risk / Under-Collected', 
    date: '2026-07-05', 
    invoiceNo: 'TRV/2026/089',
    discrepancy: '-93.2%',
    note: 'CRITICAL ALERT: Duplicate invoice hash detected across 3 distinct brand audits.'
  },
  { 
    id: 'CERT-505', 
    recyclerName: 'Vidarbha Polymers', 
    brandClient: 'Parle Agro Pvt Ltd', 
    claimedTonnage: 620, 
    verifiedTonnage: 615.0, 
    status: 'Verified', 
    date: '2026-07-11', 
    invoiceNo: 'VP-NAG-902',
    discrepancy: '-0.8%',
    note: 'Fully backed by Nagpur East Safai Sathi collection units.'
  },
  { 
    id: 'CERT-506', 
    recyclerName: 'Asha Recyclean Corp', 
    brandClient: 'Dabur India Ltd', 
    claimedTonnage: 1800, 
    verifiedTonnage: 89.0, 
    status: 'Fraud Risk / Under-Collected', 
    date: '2026-07-02', 
    invoiceNo: 'ARC/DEL/441',
    discrepancy: '-95.0%',
    note: 'FLAGGED: Physical audit confirms zero processing infrastructure at declared godown.'
  }
];

export default function App() {
  // Navigation & Role State
  const [currentRole, setCurrentRole] = useState('landing'); // 'landing', 'waste_picker', 'recycler', 'admin'
  const [collections, setCollections] = useState(INITIAL_COLLECTIONS);
  const [certificates, setCertificates] = useState(INITIAL_CERTIFICATES);
  const [demoLeads, setDemoLeads] = useState([
    { name: 'Tata Consumer Products', email: 'epr.compliance@tataconsumer.com', date: '2026-07-12' },
    { name: 'Godrej Consumer Goods', email: 'sustainability@godrejcp.com', date: '2026-07-11' }
  ]);

  // Modal / Form States
  const [isCollectionModalOpen, setIsCollectionModalOpen] = useState(false);
  const [isCertificateModalOpen, setIsCertificateModalOpen] = useState(false);
  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);
  const [selectedQRCode, setSelectedQRCode] = useState(null);

  // Waste Picker Form
  const [newCollection, setNewCollection] = useState({
    pickerName: 'Laxmi Pawar',
    village: 'Dharavi, Mumbai',
    weight: '',
    plasticType: 'HDPE / Bottles',
    photo: null,
    photoPreview: '',
    photoName: ''
  });

  // Recycler Certificate Form
  const [newCert, setNewCert] = useState({
    recyclerName: 'EcoPlast Maharashtra Ltd',
    brandClient: '',
    claimedTonnage: '',
    invoiceNo: '',
    document: null,
    documentName: ''
  });

  // AI Verification Progress State in Recycler Modal
  const [verifyingState, setVerifyingState] = useState('idle'); // 'idle', 'scanning', 'complete'
  const [aiResult, setAiResult] = useState(null);

  // Demo Lead Form
  const [demoForm, setDemoForm] = useState({ name: '', email: '', company: '' });

  // Handle Waste Picker submission
  const handleCollectionSubmit = (e) => {
    e.preventDefault();
    if (!newCollection.weight || Number(newCollection.weight) <= 0) {
      toast.error('Please enter a valid weight in kg');
      return;
    }

    const newId = `COL-${Math.floor(1000 + Math.random() * 9000)}`;
    const weightVal = parseFloat(newCollection.weight);
    const earningsVal = Math.round(weightVal * 16); // ₹16/kg base rate

    const created = {
      id: newId,
      pickerName: newCollection.pickerName,
      village: newCollection.village,
      weight: weightVal,
      plasticType: newCollection.plasticType,
      date: new Date().toISOString().split('T')[0],
      status: 'Verified',
      earnings: earningsVal,
      recycler: 'EcoPlast Maharashtra Ltd'
    };

    setCollections([created, ...collections]);
    setIsCollectionModalOpen(false);
    setSelectedQRCode(created);
    confetti({ particleCount: 80, spread: 70, origin: { y: 0.6 } });
    toast.success(`Collection ${newId} logged successfully! Digital QR ID generated.`);
  };

  // Handle Certificate AI Verification
  const handleRunAIVerification = (e) => {
    e.preventDefault();
    if (!newCert.brandClient || !newCert.claimedTonnage || !newCert.invoiceNo) {
      toast.error('Please fill in all certificate details');
      return;
    }

    setVerifyingState('scanning');
    
    setTimeout(() => {
      const claimed = parseFloat(newCert.claimedTonnage);
      // MOCKED AI Verification Engine: deterministic demo outcomes keep the story reliable.
      // Claims above 400 tonnes are intentionally under-collected in the seeded demo.
      const isFraud = claimed > 400;
      const verified = isFraud ? Math.round(claimed * 0.08 * 10) / 10 : Math.round(claimed * 0.96 * 10) / 10;
      const status = isFraud ? 'Fraud Risk / Under-Collected' : 'Verified';
      const discrepancy = isFraud ? `-${Math.round((1 - verified/claimed)*100)}%` : '-2.4%';

      const newCertObj = {
        id: `CERT-${Math.floor(510 + Math.random() * 900)}`,
        recyclerName: newCert.recyclerName,
        brandClient: newCert.brandClient,
        claimedTonnage: claimed,
        verifiedTonnage: verified,
        status: status,
        date: new Date().toISOString().split('T')[0],
        invoiceNo: newCert.invoiceNo,
        discrepancy: discrepancy,
        note: isFraud 
          ? 'AI OCR FLAG: Invoice tonnage exceeds matching collection records by over 90%. Potential fake certificate.' 
          : 'AI OCR VERIFIED: Matches physical collection events and recycler GPS logs.'
      };

      setCertificates([newCertObj, ...certificates]);
      setAiResult(newCertObj);
      setVerifyingState('complete');
      confetti({ particleCount: 100, spread: 80, origin: { y: 0.6 } });
      toast.success(isFraud ? 'AI Flagged: Potential Fake Certificate Detected!' : 'AI Verification Passed Successfully!');
    }, 2200);
  };

  return (
    <div className="min-h-screen bg-[#F7F9F6] text-[#111827] font-sans selection:bg-[#1A5C38] selection:text-white">
      <Toaster position="top-right" richColors />

      {/* --- TOP NAVBAR --- */}
      <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/80 dark:bg-[#0B1910]/80 border-b border-[#1A5C38]/10 px-4 sm:px-6 py-3 flex flex-wrap items-center justify-between gap-2 shadow-sm transition-all" data-testid="main-header">
        <div className="flex items-center gap-3 cursor-pointer shrink-0" onClick={() => setCurrentRole('landing')} data-testid="brand-logo">
          <div className="w-10 h-10 rounded-xl bg-[#1A5C38] flex items-center justify-center text-white shadow-md">
            <Recycle className="w-6 h-6 animate-pulse" />
          </div>
          <div>
            <span className="font-extrabold text-xl tracking-tight text-[#1A5C38] dark:text-[#E8F5E9]">Reuse<span className="text-[#D97706]">Plast</span></span>
            <span className="hidden sm:inline-block ml-2 text-xs px-2 py-0.5 rounded-full bg-emerald-100 dark:bg-emerald-900/50 text-[#1A5C38] dark:text-emerald-300 font-medium">India EPR Truth Engine</span>
          </div>
        </div>

        {/* Navigation & Role Switcher */}
        <div className="flex items-center justify-end gap-2 sm:gap-4 w-full sm:w-auto min-w-0">
          <button 
            onClick={() => setCurrentRole('landing')}
            className={`hidden sm:block px-3 py-1.5 rounded-lg text-sm font-medium transition-all ${currentRole === 'landing' ? 'bg-[#1A5C38] text-white shadow' : 'hover:bg-emerald-50 text-slate-600 dark:text-slate-300'}`}
            data-testid="nav-home-btn"
          >
            Overview & Problem
          </button>

          <div className="h-6 w-[1px] bg-slate-200 dark:bg-slate-700 hidden sm:block" />

          <div className="flex items-center gap-1 bg-slate-100 dark:bg-[#12261A] p-1 rounded-xl border border-slate-200 dark:border-emerald-900/30">
            <button 
              onClick={() => setCurrentRole('waste_picker')}
              className={`px-2 sm:px-3 py-1.5 rounded-lg text-xs sm:text-sm font-semibold transition-all flex items-center gap-1.5 ${currentRole === 'waste_picker' ? 'bg-[#1A5C38] text-white shadow-sm' : 'text-slate-600 dark:text-slate-300 hover:text-[#1A5C38]'}`}
              data-testid="role-picker-btn"
            >
              <User className="w-4 h-4" />
              <span className="hidden md:inline">1. Waste Picker</span>
              <span className="md:hidden">Picker</span>
            </button>
            <button 
              onClick={() => setCurrentRole('recycler')}
              className={`px-2 sm:px-3 py-1.5 rounded-lg text-xs sm:text-sm font-semibold transition-all flex items-center gap-1.5 ${currentRole === 'recycler' ? 'bg-[#1A5C38] text-white shadow-sm' : 'text-slate-600 dark:text-slate-300 hover:text-[#1A5C38]'}`}
              data-testid="role-recycler-btn"
            >
              <Building className="w-4 h-4" />
              <span className="hidden md:inline">2. Recycler & Brand</span>
              <span className="md:hidden">Recycler</span>
            </button>
            <button 
              onClick={() => setCurrentRole('admin')}
              className={`px-2 sm:px-3 py-1.5 rounded-lg text-xs sm:text-sm font-semibold transition-all flex items-center gap-1.5 ${currentRole === 'admin' ? 'bg-[#1A5C38] text-white shadow-sm' : 'text-slate-600 dark:text-slate-300 hover:text-[#1A5C38]'}`}
              data-testid="role-admin-btn"
            >
              <ShieldCheck className="w-4 h-4" />
              <span className="hidden md:inline">3. CPCB Auditor</span>
              <span className="md:hidden">Auditor</span>
            </button>
          </div>

          <button 
            onClick={() => setIsDemoModalOpen(true)}
            className="hidden lg:flex items-center gap-2 bg-[#D97706] hover:bg-[#b45309] text-white px-4 py-2 rounded-xl text-sm font-bold shadow transition-all hover:scale-[1.02]"
            data-testid="request-demo-top-btn"
          >
            Request Demo
          </button>
        </div>
      </header>

      {/* --- RENDER VIEW BASED ON ROLE --- */}
      {currentRole === 'landing' && (
        <LandingPage 
          setCurrentRole={setCurrentRole} 
          setIsDemoModalOpen={setIsDemoModalOpen} 
          collections={collections} 
          certificates={certificates}
        />
      )}

      {currentRole === 'waste_picker' && (
        <WastePickerDashboard 
          collections={collections} 
          setIsCollectionModalOpen={setIsCollectionModalOpen}
          setSelectedQRCode={setSelectedQRCode}
        />
      )}

      {currentRole === 'recycler' && (
        <RecyclerDashboard 
          certificates={certificates} 
          setIsCertificateModalOpen={setIsCertificateModalOpen}
          collections={collections}
        />
      )}

      {currentRole === 'admin' && (
        <AdminDashboard 
          collections={collections} 
          certificates={certificates}
          demoLeads={demoLeads}
        />
      )}

      {/* --- MODALS --- */}
      
      {/* 1. Waste Collection Modal */}
      {isCollectionModalOpen && (
        <div className="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 animate-in fade-in duration-200" data-testid="collection-modal">
          <div className="bg-white dark:bg-[#12261A] max-w-lg w-full rounded-2xl p-6 shadow-2xl border border-emerald-500/20 max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-2">
                <div className="p-2 rounded-xl bg-emerald-100 dark:bg-emerald-900/50 text-[#1A5C38] dark:text-emerald-300">
                  <Recycle className="w-6 h-6" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-slate-900 dark:text-white">Log Plastic Collection Event</h3>
                  <p className="text-xs text-slate-500 dark:text-slate-400">Generates unique QR Collection ID & Direct Earnings</p>
                </div>
              </div>
              <button onClick={() => setIsCollectionModalOpen(false)} className="p-2 rounded-full hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-500" data-testid="close-collection-modal">
                <X className="w-5 h-5" />
              </button>
            </div>

            <form onSubmit={handleCollectionSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-1">Waste Picker Name (Safai Sathi)</label>
                <input 
                  type="text" 
                  value={newCollection.pickerName}
                  onChange={(e) => setNewCollection({...newCollection, pickerName: e.target.value})}
                  className="w-full px-4 py-2.5 rounded-xl border border-slate-300 dark:border-slate-700 bg-transparent text-slate-900 dark:text-white focus:ring-2 focus:ring-[#1A5C38] outline-none"
                  required
                  data-testid="picker-name-input"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-1">Collection Area / Village / Ward</label>
                <input 
                  type="text" 
                  value={newCollection.village}
                  onChange={(e) => setNewCollection({...newCollection, village: e.target.value})}
                  className="w-full px-4 py-2.5 rounded-xl border border-slate-300 dark:border-slate-700 bg-transparent text-slate-900 dark:text-white focus:ring-2 focus:ring-[#1A5C38] outline-none"
                  required
                  data-testid="picker-village-input"
                />
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-1">Weight (Kg)</label>
                  <input 
                    type="number" 
                    step="0.5"
                    placeholder="e.g. 45.0"
                    value={newCollection.weight}
                    onChange={(e) => setNewCollection({...newCollection, weight: e.target.value})}
                    className="w-full px-4 py-2.5 rounded-xl border border-slate-300 dark:border-slate-700 bg-transparent text-slate-900 dark:text-white focus:ring-2 focus:ring-[#1A5C38] outline-none"
                    required
                    data-testid="picker-weight-input"
                  />
                  <p className="text-xs text-emerald-600 dark:text-emerald-400 mt-1 font-medium">Earns approx ₹16 / kg instantly</p>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-1">Plastic Polymer Type</label>
                  <select 
                    value={newCollection.plasticType}
                    onChange={(e) => setNewCollection({...newCollection, plasticType: e.target.value})}
                    className="w-full px-4 py-2.5 rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-[#0B1910] text-slate-900 dark:text-white focus:ring-2 focus:ring-[#1A5C38] outline-none"
                    data-testid="picker-plastic-type"
                  >
                    <option value="HDPE / Bottles">HDPE / Hard Bottles</option>
                    <option value="PET Bottles">PET Clear Bottles</option>
                    <option value="LDPE Films">LDPE Carry Bags & Films</option>
                    <option value="PP Caps & Cups">PP Caps & Cups</option>
                    <option value="Mixed Rigid">Mixed Rigid Plastics</option>
                  </select>
                </div>
              </div>

              <div>
                <label className="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-1">Photo of Collected Waste (Proof)</label>
                <div className="border-2 border-dashed border-slate-300 dark:border-slate-700 rounded-xl p-4 text-center hover:border-[#1A5C38] transition cursor-pointer bg-slate-50 dark:bg-emerald-950/20">
                  <input 
                    type="file" 
                    accept="image/*"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if(file) {
                        const reader = new FileReader();
                        reader.onload = () => setNewCollection({...newCollection, photo: file, photoName: file.name, photoPreview: reader.result});
                        reader.readAsDataURL(file);
                        toast.success(`Photo uploaded: ${file.name}`);
                      }
                    }}
                    className="hidden" 
                    id="collection-photo-upload"
                    data-testid="collection-photo-input"
                  />
                  <label htmlFor="collection-photo-upload" className="cursor-pointer flex flex-col items-center">
                    {newCollection.photoPreview ? (
                      <img src={newCollection.photoPreview} alt="Uploaded plastic collection proof" className="h-28 w-full object-cover rounded-xl mb-3" data-testid="collection-photo-preview" />
                    ) : <Upload className="w-8 h-8 text-[#1A5C38] mb-1" />}
                    <span className="text-sm font-medium text-slate-700 dark:text-slate-300">
                      {newCollection.photoName ? newCollection.photoName : "Click to snap or upload plastic bag photo"}
                    </span>
                    <span className="text-xs text-slate-400 mt-0.5">GPS location & timestamp auto-tagged</span>
                  </label>
                </div>
              </div>

              <div className="pt-2">
                <button 
                  type="submit"
                  className="w-full py-3 px-4 rounded-xl bg-[#1A5C38] hover:bg-[#14482C] text-white font-bold shadow-lg transition-all flex items-center justify-center gap-2"
                  data-testid="submit-collection-btn"
                >
                  <QrCode className="w-5 h-5" />
                  Generate Verified Collection ID & QR
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* 2. QR Code Display Modal after successful creation */}
      {selectedQRCode && !isCollectionModalOpen && (
        <div className="fixed inset-0 z-50 bg-black/70 backdrop-blur-md flex items-center justify-center p-4 animate-in fade-in duration-200" data-testid="qr-modal">
          <div className="bg-white dark:bg-[#12261A] max-w-sm w-full rounded-2xl p-6 shadow-2xl border border-emerald-500/30 text-center">
            <div className="w-12 h-12 bg-emerald-100 dark:bg-emerald-900/50 text-[#1A5C38] dark:text-emerald-300 rounded-full flex items-center justify-center mx-auto mb-3 shadow">
              <CheckCircle2 className="w-7 h-7" />
            </div>
            <h3 className="text-2xl font-black text-slate-900 dark:text-white">Collection Verified!</h3>
            <p className="text-xs text-slate-500 dark:text-slate-400 mt-0.5">Registered on ReusePlast Ledger</p>

            <div className="my-5 p-4 bg-slate-50 dark:bg-[#0B1910] rounded-2xl border border-slate-200 dark:border-emerald-900/40 flex flex-col items-center">
              <div className="bg-white p-3 rounded-xl shadow-inner mb-3">
                <QRCodeSVG value={`https://reuseplast.in/verify/${selectedQRCode.id}`} size={160} level="H" />
              </div>
              <span className="font-mono font-bold text-lg text-[#1A5C38] dark:text-emerald-400">{selectedQRCode.id}</span>
              <div className="text-xs text-slate-600 dark:text-slate-300 mt-2 space-y-1 w-full text-left px-2">
                <div className="flex justify-between"><span>Picker:</span> <span className="font-semibold">{selectedQRCode.pickerName}</span></div>
                <div className="flex justify-between"><span>Weight:</span> <span className="font-semibold text-emerald-600">{selectedQRCode.weight} kg</span></div>
                <div className="flex justify-between"><span>Earnings:</span> <span className="font-semibold text-amber-600">₹{selectedQRCode.earnings}</span></div>
                <div className="flex justify-between"><span>Location:</span> <span className="font-semibold">{selectedQRCode.village}</span></div>
              </div>
            </div>

            <button 
              onClick={() => setSelectedQRCode(null)}
              className="w-full py-3 rounded-xl bg-[#1A5C38] text-white font-bold shadow hover:bg-[#14482C] transition"
              data-testid="close-qr-modal"
            >
              Done & Return to Dashboard
            </button>
          </div>
        </div>
      )}

      {/* 3. Recycler Certificate AI Verification Modal */}
      {isCertificateModalOpen && (
        <div className="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 animate-in fade-in duration-200" data-testid="certificate-modal">
          <div className="bg-white dark:bg-[#12261A] max-w-xl w-full rounded-2xl p-6 shadow-2xl border border-emerald-500/20 max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-2">
                <div className="p-2 rounded-xl bg-emerald-100 dark:bg-emerald-900/50 text-[#1A5C38] dark:text-emerald-300">
                  <ShieldCheck className="w-6 h-6" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-slate-900 dark:text-white">AI Verification Engine</h3>
                  <p className="text-xs text-slate-500 dark:text-slate-400">Cross-examine recycler invoice against collection proofs</p>
                </div>
              </div>
              <button onClick={() => { setIsCertificateModalOpen(false); setVerifyingState('idle'); }} className="p-2 rounded-full hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-500" data-testid="close-cert-modal">
                <X className="w-5 h-5" />
              </button>
            </div>

            {verifyingState === 'idle' && (
              <form onSubmit={handleRunAIVerification} className="space-y-4">
                <div>
                  <label className="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-1">Recycler / Processing Facility Name</label>
                  <select 
                    value={newCert.recyclerName}
                    onChange={(e) => setNewCert({...newCert, recyclerName: e.target.value})}
                    className="w-full px-4 py-2.5 rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-[#0B1910] text-slate-900 dark:text-white focus:ring-2 focus:ring-[#1A5C38] outline-none"
                    data-testid="cert-recycler-select"
                  >
                    <option value="EcoPlast Maharashtra Ltd">EcoPlast Maharashtra Ltd (Capacity: 500t/mo)</option>
                    <option value="Shakti Polymers & Recycling">Shakti Polymers & Recycling (Capacity: 200t/mo)</option>
                    <option value="GreenCycle Industries">GreenCycle Industries (Capacity: 1200t/mo)</option>
                    <option value="Technova Recycling India">Technova Recycling India (Capacity: 350t/mo)</option>
                    <option value="Vidarbha Polymers">Vidarbha Polymers (Capacity: 700t/mo)</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-1">Brand Owner / EPR Client</label>
                  <input 
                    type="text" 
                    placeholder="e.g. Hindustan Unilever / Pepsico / Nestlé"
                    value={newCert.brandClient}
                    onChange={(e) => setNewCert({...newCert, brandClient: e.target.value})}
                    className="w-full px-4 py-2.5 rounded-xl border border-slate-300 dark:border-slate-700 bg-transparent text-slate-900 dark:text-white focus:ring-2 focus:ring-[#1A5C38] outline-none"
                    required
                    data-testid="cert-brand-input"
                  />
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-1">Claimed Tonnage (Tonnes)</label>
                    <input 
                      type="number" 
                      placeholder="e.g. 450"
                      value={newCert.claimedTonnage}
                      onChange={(e) => setNewCert({...newCert, claimedTonnage: e.target.value})}
                      className="w-full px-4 py-2.5 rounded-xl border border-slate-300 dark:border-slate-700 bg-transparent text-slate-900 dark:text-white focus:ring-2 focus:ring-[#1A5C38] outline-none"
                      required
                      data-testid="cert-tonnage-input"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-1">Invoice / Certificate No.</label>
                    <input 
                      type="text" 
                      placeholder="e.g. EPL/2026/891"
                      value={newCert.invoiceNo}
                      onChange={(e) => setNewCert({...newCert, invoiceNo: e.target.value})}
                      className="w-full px-4 py-2.5 rounded-xl border border-slate-300 dark:border-slate-700 bg-transparent text-slate-900 dark:text-white focus:ring-2 focus:ring-[#1A5C38] outline-none"
                      required
                      data-testid="cert-invoice-input"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-1">Upload PDF Invoice / Processing Proof</label>
                  <div className="border-2 border-dashed border-slate-300 dark:border-slate-700 rounded-xl p-4 text-center hover:border-[#1A5C38] transition cursor-pointer bg-slate-50 dark:bg-emerald-950/20">
                    <input 
                      type="file" 
                      accept=".pdf,.png,.jpg"
                      onChange={(e) => {
                        if(e.target.files[0]) {
                          setNewCert({...newCert, documentName: e.target.files[0].name});
                          toast.success(`Document loaded: ${e.target.files[0].name}`);
                        }
                      }}
                      className="hidden" 
                      id="cert-doc-upload"
                      data-testid="cert-file-input"
                    />
                    <label htmlFor="cert-doc-upload" className="cursor-pointer flex flex-col items-center">
                      <Upload className="w-8 h-8 text-[#1A5C38] mb-1" />
                      <span className="text-sm font-medium text-slate-700 dark:text-slate-300">
                        {newCert.documentName ? newCert.documentName : "Upload Recycler Invoice (PDF / Scanned Photo)"}
                      </span>
                      <span className="text-xs text-slate-400 mt-0.5">AI OCR will auto-extract tonnage & cross-match collection IDs</span>
                    </label>
                  </div>
                </div>

                <div className="pt-2">
                  <button 
                    type="submit"
                    className="w-full py-3 px-4 rounded-xl bg-[#1A5C38] hover:bg-[#14482C] text-white font-bold shadow-lg transition-all flex items-center justify-center gap-2"
                    data-testid="run-ai-verification-btn"
                  >
                    <Sparkles className="w-5 h-5 text-amber-300 animate-spin" />
                    Run AI Verification Engine
                  </button>
                </div>
              </form>
            )}

            {verifyingState === 'scanning' && (
              <div className="py-12 flex flex-col items-center justify-center text-center space-y-4">
                <div className="w-16 h-16 rounded-full bg-emerald-100 dark:bg-emerald-900/50 flex items-center justify-center text-[#1A5C38] animate-bounce">
                  <Sparkles className="w-8 h-8 animate-spin text-amber-500" />
                </div>
                <h4 className="text-xl font-bold text-slate-900 dark:text-white">AI Engine Running OCR & Cross-Checking...</h4>
                <p className="text-sm text-slate-500 max-w-xs">Scanning collection GPS logs, matching unique QR IDs, and computing actual plant processing capacity.</p>
                <div className="w-full bg-slate-200 dark:bg-slate-700 h-2 rounded-full overflow-hidden max-w-xs">
                  <div className="bg-[#1A5C38] h-full animate-pulse w-3/4 rounded-full" />
                </div>
              </div>
            )}

            {verifyingState === 'complete' && aiResult && (
              <div className="py-6 space-y-4 text-center">
                <div className={`w-16 h-16 rounded-full flex items-center justify-center mx-auto shadow-lg ${aiResult.status === 'Verified' ? 'bg-emerald-100 text-emerald-700' : 'bg-red-100 text-red-600'}`}>
                  {aiResult.status === 'Verified' ? <CheckCircle2 className="w-10 h-10" /> : <AlertTriangle className="w-10 h-10" />}
                </div>

                <div>
                  <h4 className="text-2xl font-black text-slate-900 dark:text-white">{aiResult.status}</h4>
                  <p className="text-xs text-slate-500 mt-1">Certificate ID: <span className="font-mono font-bold">{aiResult.id}</span></p>
                </div>

                <div className="p-4 bg-slate-50 dark:bg-[#0B1910] rounded-2xl border border-slate-200 dark:border-emerald-900/40 text-left space-y-2 text-sm">
                  <div className="flex justify-between"><span>Recycler:</span> <span className="font-semibold">{aiResult.recyclerName}</span></div>
                  <div className="flex justify-between"><span>Brand Client:</span> <span className="font-semibold">{aiResult.brandClient}</span></div>
                  <div className="flex justify-between"><span>Claimed Tonnage:</span> <span className="font-bold text-slate-900 dark:text-white">{aiResult.claimedTonnage} Tonnes</span></div>
                  <div className="flex justify-between"><span>Real Verified Tonnage:</span> <span className={`font-bold ${aiResult.status === 'Verified' ? 'text-emerald-600' : 'text-red-500'}`}>{aiResult.verifiedTonnage} Tonnes</span></div>
                  <div className="pt-2 border-t border-slate-200 dark:border-slate-800 text-xs text-slate-600 dark:text-slate-300">
                    <span className="font-bold text-amber-600">AI Note:</span> {aiResult.note}
                  </div>
                </div>

                <button 
                  onClick={() => { setIsCertificateModalOpen(false); setVerifyingState('idle'); }}
                  className="w-full py-3 rounded-xl bg-[#1A5C38] text-white font-bold shadow hover:bg-[#14482C] transition"
                  data-testid="close-ai-result-btn"
                >
                  View in Recycler Ledger
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* 4. Request a Demo Modal */}
      {isDemoModalOpen && (
        <div className="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 animate-in fade-in duration-200" data-testid="demo-modal">
          <div className="bg-white dark:bg-[#12261A] max-w-md w-full rounded-2xl p-6 shadow-2xl border border-emerald-500/20">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-2">
                <div className="p-2 rounded-xl bg-amber-100 text-amber-700">
                  <Building2 className="w-6 h-6" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-slate-900 dark:text-white">Request Brand / CPCB Demo</h3>
                  <p className="text-xs text-slate-500 dark:text-slate-400">Deploy ReusePlast API for EPR Compliance</p>
                </div>
              </div>
              <button onClick={() => setIsDemoModalOpen(false)} className="p-2 rounded-full hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-500" data-testid="close-demo-modal">
                <X className="w-5 h-5" />
              </button>
            </div>

            <form onSubmit={(e) => {
              e.preventDefault();
              if(!demoForm.name || !demoForm.email) {
                toast.error('Please provide name and email');
                return;
              }
              setDemoLeads([ { name: demoForm.name, email: demoForm.email, company: demoForm.company || 'Enterprise Brand', date: new Date().toISOString().split('T')[0] }, ...demoLeads ]);
              setIsDemoModalOpen(false);
              setDemoForm({ name: '', email: '', company: '' });
              confetti({ particleCount: 60, spread: 60, origin: { y: 0.6 } });
              toast.success('Demo request received! Our climate-tech team will contact you within 24 hours.');
            }} className="space-y-4">
              <div>
                <label className="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-1">Your Full Name</label>
                <input 
                  type="text" 
                  placeholder="e.g. Vikramaditya Roy"
                  value={demoForm.name}
                  onChange={(e) => setDemoForm({...demoForm, name: e.target.value})}
                  className="w-full px-4 py-2.5 rounded-xl border border-slate-300 dark:border-slate-700 bg-transparent text-slate-900 dark:text-white focus:ring-2 focus:ring-[#1A5C38] outline-none"
                  required
                  data-testid="demo-name-input"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-1">Work Email</label>
                <input 
                  type="email" 
                  placeholder="e.g. vikram@brand.com"
                  value={demoForm.email}
                  onChange={(e) => setDemoForm({...demoForm, email: e.target.value})}
                  className="w-full px-4 py-2.5 rounded-xl border border-slate-300 dark:border-slate-700 bg-transparent text-slate-900 dark:text-white focus:ring-2 focus:ring-[#1A5C38] outline-none"
                  required
                  data-testid="demo-email-input"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-1">Company / Organization / CPCB Dept</label>
                <input 
                  type="text" 
                  placeholder="e.g. Hindustan Unilever / CPCB Delhi"
                  value={demoForm.company}
                  onChange={(e) => setDemoForm({...demoForm, company: e.target.value})}
                  className="w-full px-4 py-2.5 rounded-xl border border-slate-300 dark:border-slate-700 bg-transparent text-slate-900 dark:text-white focus:ring-2 focus:ring-[#1A5C38] outline-none"
                  data-testid="demo-company-input"
                />
              </div>

              <button 
                type="submit"
                className="w-full py-3 px-4 rounded-xl bg-[#D97706] hover:bg-[#b45309] text-white font-bold shadow-lg transition-all flex items-center justify-center gap-2"
                data-testid="submit-demo-btn"
              >
                Submit Demo Request
              </button>
            </form>
          </div>
        </div>
      )}

    </div>
  );
}

// --- LANDING PAGE COMPONENT ---
function LandingPage({ setCurrentRole, setIsDemoModalOpen, collections, certificates }) {
  const verifiedCount = collections.filter(c => c.status === 'Verified').length;
  const totalTonnage = collections.reduce((acc, curr) => acc + curr.weight, 0) / 1000; // in tonnes
  const fraudCertCount = certificates.filter(c => c.status.includes('Fraud')).length;

  return (
    <div className="space-y-20 pb-24" data-testid="landing-page">
      {/* Hero Section */}
      <section className="relative overflow-hidden pt-16 pb-24 px-6 lg:px-16 bg-gradient-to-b from-[#0B1910] via-[#12261A] to-[#0B1910] text-white">
        <div className="absolute inset-0 opacity-15 bg-[radial-gradient(#2E7D32_1px,transparent_1px)] [background-size:16px_16px]" />
        
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 items-center relative z-10">
          <div className="lg:col-span-7 space-y-6">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-emerald-500/10 border border-emerald-500/30 text-emerald-400 text-xs font-semibold">
              <Sparkles className="w-4 h-4 text-amber-400 animate-spin" />
              <span>Fixing India&apos;s ₹355 Cr EPR Plastic Fraud</span>
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight leading-none">
              Proof Over Paperwork. <br />
              <span className="text-emerald-400">Authentic Plastic Recycling</span> for India.
            </h1>

            <p className="text-slate-300 text-base sm:text-lg max-w-2xl leading-relaxed">
              India&apos;s Extended Producer Responsibility (EPR) system suffers from hundreds of thousands of fake recycling certificates. <span className="text-emerald-300 font-semibold">ReusePlast</span> is the digital verification layer connecting informal waste pickers to recyclers and brands with immutable AI-backed collection proof.
            </p>

            <div className="flex flex-wrap gap-4 pt-2">
              <button 
                onClick={() => setCurrentRole('waste_picker')}
                className="px-6 py-3.5 rounded-2xl bg-emerald-600 hover:bg-emerald-500 text-white font-bold shadow-lg shadow-emerald-900/40 transition flex items-center gap-2"
                data-testid="hero-try-picker-btn"
              >
                <User className="w-5 h-5" />
                Explore Waste Picker Flow
                <ArrowRight className="w-4 h-4" />
              </button>

              <button 
                onClick={() => setCurrentRole('recycler')}
                className="px-6 py-3.5 rounded-2xl bg-[#12261A] hover:bg-emerald-900/60 text-emerald-300 border border-emerald-500/30 font-bold transition flex items-center gap-2"
                data-testid="hero-try-recycler-btn"
              >
                <Building className="w-5 h-5" />
                Test AI Verification Engine
              </button>
            </div>

            {/* Quick Stats Pill */}
            <div className="grid grid-cols-3 gap-4 pt-6 border-t border-emerald-900/40">
              <div>
                <div className="text-2xl font-black text-emerald-400">700k+</div>
                <div className="text-xs text-slate-400">Fake Certificates (CSE Report)</div>
              </div>
              <div>
                <div className="text-2xl font-black text-amber-400">₹355 Cr</div>
                <div className="text-xs text-slate-400">CPCB Fines on Violators</div>
              </div>
              <div>
                <div className="text-2xl font-black text-emerald-300">100%</div>
                <div className="text-xs text-slate-400">Waste Picker Linked Trail</div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-5 space-y-4">
            {/* Real waste-picker photo — the human cost behind every certificate */}
            <div className="relative rounded-3xl overflow-hidden border border-emerald-500/25 shadow-2xl group" data-testid="hero-picker-photo">
              <img 
                src={PICKER_PHOTO_HERO} 
                alt="Safai Sathi carrying collected plastic across a landfill in India" 
                className="w-full h-56 sm:h-64 object-cover object-center transition-transform duration-700 group-hover:scale-[1.03]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0B1910] via-[#0B1910]/40 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4 space-y-1">
                <div className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full bg-amber-500/90 text-slate-950 text-[10px] font-black uppercase tracking-wider">
                  <User className="w-3 h-3" /> On the Ground
                </div>
                <p className="text-sm font-bold text-white leading-tight">Behind every certificate is a Safai Sathi like her.</p>
                <p className="text-[11px] text-emerald-200/90">ReusePlast anchors each recycled tonne to a real, verified collection event.</p>
              </div>
            </div>

            <div className="bg-[#12261A]/90 border border-emerald-500/30 rounded-3xl p-6 shadow-2xl relative backdrop-blur-xl">
              <div className="absolute -top-3 -right-3 bg-amber-500 text-slate-950 text-xs font-black px-3 py-1 rounded-full uppercase tracking-wider shadow">
                Live AI Engine
              </div>
              
              <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2">
                <ShieldCheck className="w-5 h-5 text-emerald-400" />
                Recent Audit Results
              </h3>

              <div className="space-y-3">
                {certificates.slice(0, 3).map((cert, idx) => (
                  <div key={idx} className="p-3.5 rounded-2xl bg-[#0B1910] border border-emerald-900/40 flex items-center justify-between text-sm">
                    <div>
                      <div className="font-bold text-white text-xs">{cert.recyclerName}</div>
                      <div className="text-slate-400 text-[11px]">{cert.brandClient}</div>
                    </div>
                    <div className="text-right">
                      <span className={`inline-block px-2 py-0.5 rounded-md text-[11px] font-bold ${cert.status === 'Verified' ? 'bg-emerald-950 text-emerald-400 border border-emerald-800' : 'bg-red-950 text-red-400 border border-red-800'}`}>
                        {cert.status === 'Verified' ? 'Verified' : 'Fraud Risk'}
                      </span>
                      <div className="text-[10px] text-slate-400 mt-0.5">{cert.claimedTonnage} Tonnes</div>
                    </div>
                  </div>
                ))}
              </div>

              <button 
                onClick={() => setCurrentRole('admin')}
                className="w-full mt-4 py-2.5 rounded-xl bg-emerald-900/40 hover:bg-emerald-900/70 text-emerald-300 text-xs font-bold transition flex items-center justify-center gap-1"
                data-testid="hero-view-all-audits"
              >
                View Full CPCB Audit Dashboard <ArrowRight className="w-3.5 h-3.5" />
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* The Problem Section */}
      <section className="max-w-7xl mx-auto px-6 lg:px-16">
        <div className="text-center max-w-3xl mx-auto mb-10 space-y-4">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-700 dark:text-emerald-400">The Ground Reality</span>
          <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 dark:text-white">Why India&apos;s EPR Plastic Compliance is Broken</h2>
          <p className="text-slate-600 dark:text-slate-300 text-base">
            Brand owners pay millions for recycling certificates to meet government quotas. But without physical verification, paper trails are easily forged.
          </p>
        </div>

        {/* Real-world context banner — puts a face on the "phantom recycling" story */}
        <div className="relative rounded-3xl overflow-hidden mb-12 shadow-xl border border-slate-200 dark:border-emerald-900/40" data-testid="reality-banner">
          <img 
            src={PICKER_PHOTO_REALITY}
            alt="A waste picker walking through an Indian landfill carrying a sack of collected plastic"
            className="w-full h-64 sm:h-80 object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0B1910]/95 via-[#0B1910]/70 to-transparent" />
          <div className="absolute inset-0 flex items-center">
            <div className="max-w-lg p-6 sm:p-10 space-y-3">
              <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-amber-500/90 text-slate-950 text-[11px] font-black uppercase tracking-wider">
                <AlertTriangle className="w-3.5 h-3.5" /> The Hidden Workforce
              </div>
              <h3 className="text-2xl sm:text-3xl font-black text-white leading-tight">1.5 million Safai Sathis. Zero paper trail.</h3>
              <p className="text-slate-200 text-sm leading-relaxed">
                India&apos;s informal waste pickers physically collect most of the country&apos;s recycled plastic — yet EPR certificates rarely mention them. Their labour is real. Most certificates aren&apos;t.
              </p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="p-8 rounded-3xl bg-white dark:bg-[#12261A] border border-slate-200 dark:border-emerald-900/30 shadow-sm space-y-4">
            <div className="w-12 h-12 rounded-2xl bg-red-100 text-red-600 flex items-center justify-center font-bold text-xl">
              <AlertTriangle className="w-6 h-6" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 dark:text-white">Phantom Recycling</h3>
            <p className="text-slate-600 dark:text-slate-300 text-sm leading-relaxed">
              Recyclers issue certificates for 38x their real physical processing capacity. Plastic remains uncollected in landfills while paper certificates trade online.
            </p>
          </div>

          <div className="p-8 rounded-3xl bg-white dark:bg-[#12261A] border border-slate-200 dark:border-emerald-900/30 shadow-sm space-y-4">
            <div className="w-12 h-12 rounded-2xl bg-amber-100 text-amber-700 flex items-center justify-center font-bold text-xl">
              <User className="w-6 h-6" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 dark:text-white">Waste Pickers Cut Out</h3>
            <p className="text-slate-600 dark:text-slate-300 text-sm leading-relaxed">
              Informal Safai Sathis do the grueling work of collection for as little as ₹100/day, completely excluded from the certificate value chain and digital rewards.
            </p>
          </div>

          <div className="p-8 rounded-3xl bg-white dark:bg-[#12261A] border border-slate-200 dark:border-emerald-900/30 shadow-sm space-y-4">
            <div className="w-12 h-12 rounded-2xl bg-emerald-100 text-[#1A5C38] flex items-center justify-center font-bold text-xl">
              <ShieldCheck className="w-6 h-6" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 dark:text-white">The ReusePlast Solution</h3>
            <p className="text-slate-600 dark:text-slate-300 text-sm leading-relaxed">
              We anchor every recycling certificate to immutable waste picker QR collection IDs verified by an AI OCR cross-matching engine.
            </p>
          </div>
        </div>
      </section>

      {/* Role Selector Cards */}
      <section className="max-w-7xl mx-auto px-6 lg:px-16">
        <div className="bg-gradient-to-r from-[#1A5C38] to-[#2E7D32] rounded-3xl p-8 lg:p-12 text-white shadow-2xl">
          <div className="max-w-2xl mb-10 space-y-3">
            <span className="text-xs uppercase font-extrabold tracking-widest text-amber-300">Interactive Demo Experience</span>
            <h2 className="text-3xl font-black">Choose a Role to Explore the Platform</h2>
            <p className="text-emerald-100 text-sm">Experience how ReusePlast serves waste pickers, recycling factories, and CPCB regulators.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div 
              onClick={() => setCurrentRole('waste_picker')}
              className="bg-white/10 hover:bg-white/20 border border-white/20 p-6 rounded-2xl cursor-pointer transition-all hover:-translate-y-1"
              data-testid="select-role-picker"
            >
              <div className="w-10 h-10 rounded-xl bg-white text-[#1A5C38] flex items-center justify-center font-bold mb-4">
                <User className="w-6 h-6" />
              </div>
              <h3 className="text-xl font-bold mb-2">1. Waste Picker Portal</h3>
              <p className="text-xs text-emerald-100 mb-4">Mobile-first interface to log collection events, view earnings & get QR codes.</p>
              <span className="inline-flex items-center gap-1 text-xs font-bold text-amber-300">Launch Picker View <ArrowRight className="w-3.5 h-3.5" /></span>
            </div>

            <div 
              onClick={() => setCurrentRole('recycler')}
              className="bg-white/10 hover:bg-white/20 border border-white/20 p-6 rounded-2xl cursor-pointer transition-all hover:-translate-y-1"
              data-testid="select-role-recycler"
            >
              <div className="w-10 h-10 rounded-xl bg-white text-[#1A5C38] flex items-center justify-center font-bold mb-4">
                <Building className="w-6 h-6" />
              </div>
              <h3 className="text-xl font-bold mb-2">2. Recycler & Brand Portal</h3>
              <p className="text-xs text-emerald-100 mb-4">Upload invoices and run the AI Verification Engine against real collections.</p>
              <span className="inline-flex items-center gap-1 text-xs font-bold text-amber-300">Launch Recycler View <ArrowRight className="w-3.5 h-3.5" /></span>
            </div>

            <div 
              onClick={() => setCurrentRole('admin')}
              className="bg-white/10 hover:bg-white/20 border border-white/20 p-6 rounded-2xl cursor-pointer transition-all hover:-translate-y-1"
              data-testid="select-role-admin"
            >
              <div className="w-10 h-10 rounded-xl bg-white text-[#1A5C38] flex items-center justify-center font-bold mb-4">
                <ShieldCheck className="w-6 h-6" />
              </div>
              <h3 className="text-xl font-bold mb-2">3. CPCB Auditor Dashboard</h3>
              <p className="text-xs text-emerald-100 mb-4">Monitor regional fraud risk, flag phantom tonnage, and audit provenance.</p>
              <span className="inline-flex items-center gap-1 text-xs font-bold text-amber-300">Launch Auditor View <ArrowRight className="w-3.5 h-3.5" /></span>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="max-w-7xl mx-auto px-6 lg:px-16 pt-12 border-t border-slate-200 dark:border-emerald-900/30 flex flex-col md:flex-row items-center justify-between text-sm text-slate-500">
        <div className="flex items-center gap-2 mb-4 md:mb-0">
          <div className="w-8 h-8 rounded-lg bg-[#1A5C38] flex items-center justify-center text-white font-bold">
            <Recycle className="w-4 h-4" />
          </div>
          <span className="font-bold text-slate-900 dark:text-white">ReusePlast India</span>
          <span className="text-xs">© 2026 Climate & Civic Tech Initiative</span>
        </div>
        <div className="flex items-center gap-6">
          <button onClick={() => setIsDemoModalOpen(true)} className="hover:text-[#1A5C38] font-medium" data-testid="footer-demo-btn">Request Enterprise Demo</button>
          <span className="text-slate-300">|</span>
          <span className="text-xs text-emerald-700 dark:text-emerald-400 font-semibold">CPCB EPR Compliant Layer v2.4</span>
        </div>
      </footer>
    </div>
  );
}

// --- WASTE PICKER DASHBOARD ---
function WastePickerDashboard({ collections, setIsCollectionModalOpen, setSelectedQRCode }) {
  // Filter for demo or search
  const [searchTerm, setSearchTerm] = useState('');
  const pickerCollections = collections.filter(c => 
    c.pickerName.toLowerCase().includes(searchTerm.toLowerCase()) || 
    c.village.toLowerCase().includes(searchTerm.toLowerCase()) ||
    c.id.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalKg = collections.reduce((acc, curr) => acc + curr.weight, 0);
  const totalEarnings = collections.reduce((acc, curr) => acc + curr.earnings, 0);

  return (
    <div className="max-w-7xl mx-auto px-6 py-8 space-y-8" data-testid="waste-picker-dashboard">
      {/* Banner */}
      <div className="bg-gradient-to-r from-emerald-800 to-[#1A5C38] rounded-3xl p-6 md:p-8 text-white shadow-xl flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="space-y-2">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 text-xs font-semibold">
            <User className="w-3.5 h-3.5 text-amber-300" />
            <span>Safai Sathi Mobile-First Portal</span>
          </div>
          <h1 className="text-2xl md:text-3xl font-black">Welcome, Laxmi Pawar & Partner Pickers</h1>
          <p className="text-emerald-100 text-sm max-w-xl">
            Log your daily plastic collections instantly. Get unique QR collection IDs, transparent earnings, and direct connection to certified recyclers.
          </p>
        </div>

        <button 
          onClick={() => setIsCollectionModalOpen(true)}
          className="px-6 py-3.5 rounded-2xl bg-amber-500 hover:bg-amber-600 text-slate-950 font-black shadow-lg transition-all flex items-center gap-2 hover:scale-105"
          data-testid="open-log-collection-modal"
        >
          <Plus className="w-5 h-5" />
          + Log New Collection
        </button>
      </div>

      {/* Running Tally Stats */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
        <div className="p-6 rounded-3xl bg-white dark:bg-[#12261A] border border-slate-200 dark:border-emerald-900/30 shadow-sm space-y-2">
          <div className="text-xs font-bold uppercase tracking-wider text-slate-500">Verified Collections</div>
          <div className="text-3xl font-black text-[#1A5C38] dark:text-emerald-400">{collections.length} Events</div>
          <div className="text-xs text-emerald-600 font-medium">100% accepted in CPCB audit trail</div>
        </div>

        <div className="p-6 rounded-3xl bg-white dark:bg-[#12261A] border border-slate-200 dark:border-emerald-900/30 shadow-sm space-y-2">
          <div className="text-xs font-bold uppercase tracking-wider text-slate-500">Total Tonnage Logged</div>
          <div className="text-3xl font-black text-slate-900 dark:text-white">{(totalKg / 1000).toFixed(2)} Tonnes</div>
          <div className="text-xs text-slate-500 font-medium">{totalKg.toLocaleString()} kg of plastic recovered</div>
        </div>

        <div className="p-6 rounded-3xl bg-white dark:bg-[#12261A] border border-slate-200 dark:border-emerald-900/30 shadow-sm space-y-2">
          <div className="text-xs font-bold uppercase tracking-wider text-slate-500">Estimated Earnings</div>
          <div className="text-3xl font-black text-amber-600 dark:text-amber-400">₹{totalEarnings.toLocaleString()}</div>
          <div className="text-xs text-amber-600 font-medium">Includes direct EPR bonus payout</div>
        </div>
      </div>

      {/* Collection Records Table & QR Action */}
      <div className="bg-white dark:bg-[#12261A] rounded-3xl p-6 shadow-sm border border-slate-200 dark:border-emerald-900/30 space-y-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div>
            <h3 className="text-xl font-bold text-slate-900 dark:text-white">Recent Collection Events & QR IDs</h3>
            <p className="text-xs text-slate-500">Click any row or QR icon to inspect the immutable digital certificate.</p>
          </div>

          <div className="relative w-full sm:w-72">
            <Search className="absolute left-3.5 top-3 w-4 h-4 text-slate-400" />
            <input 
              type="text"
              placeholder="Search by ID, picker or village..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-10 pr-4 py-2 rounded-xl border border-slate-200 dark:border-slate-700 bg-transparent text-sm focus:ring-2 focus:ring-[#1A5C38] outline-none"
              data-testid="search-picker-input"
            />
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="border-b border-slate-200 dark:border-slate-800 text-xs font-bold uppercase text-slate-400">
                <th className="py-3 px-4">Collection ID</th>
                <th className="py-3 px-4">Safai Sathi</th>
                <th className="py-3 px-4">Location</th>
                <th className="py-3 px-4">Weight (kg)</th>
                <th className="py-3 px-4">Plastic Type</th>
                <th className="py-3 px-4">Earnings</th>
                <th className="py-3 px-4">Status</th>
                <th className="py-3 px-4 text-right">QR Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100 dark:divide-slate-800 text-sm">
              {pickerCollections.map((col, idx) => (
                <tr key={idx} className="hover:bg-slate-50 dark:hover:bg-emerald-950/20 transition">
                  <td className="py-3.5 px-4 font-mono font-bold text-[#1A5C38] dark:text-emerald-400">{col.id}</td>
                  <td className="py-3.5 px-4 font-semibold text-slate-900 dark:text-white">{col.pickerName}</td>
                  <td className="py-3.5 px-4 text-slate-600 dark:text-slate-300">{col.village}</td>
                  <td className="py-3.5 px-4 font-bold text-slate-900 dark:text-white">{col.weight} kg</td>
                  <td className="py-3.5 px-4 text-slate-600 dark:text-slate-300">{col.plasticType}</td>
                  <td className="py-3.5 px-4 font-semibold text-amber-600">₹{col.earnings}</td>
                  <td className="py-3.5 px-4">
                    <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-bold bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-300 border border-emerald-300">
                      <CheckCircle2 className="w-3.5 h-3.5" /> {col.status}
                    </span>
                  </td>
                  <td className="py-3.5 px-4 text-right">
                    <button 
                      onClick={() => setSelectedQRCode(col)}
                      className="px-3 py-1.5 rounded-xl bg-emerald-100 hover:bg-emerald-200 text-[#1A5C38] font-bold text-xs inline-flex items-center gap-1 transition"
                      data-testid={`view-qr-${col.id}`}
                    >
                      <QrCode className="w-4 h-4" /> View QR
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

// --- RECYCLER & BRAND DASHBOARD ---
function RecyclerDashboard({ certificates, setIsCertificateModalOpen, collections }) {
  const [searchTerm, setSearchTerm] = useState('');
  const filteredCerts = certificates.filter(c => 
    c.recyclerName.toLowerCase().includes(searchTerm.toLowerCase()) ||
    c.brandClient.toLowerCase().includes(searchTerm.toLowerCase()) ||
    c.id.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="max-w-7xl mx-auto px-6 py-8 space-y-8" data-testid="recycler-dashboard">
      {/* Banner */}
      <div className="bg-gradient-to-r from-slate-900 via-[#12261A] to-[#1A5C38] rounded-3xl p-6 md:p-8 text-white shadow-xl flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="space-y-2">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-amber-500/20 border border-amber-500/35 text-amber-300 text-xs font-semibold">
            <ShieldCheck className="w-3.5 h-3.5" />
            <span>AI Verification Engine for Recyclers & Brand Owners</span>
          </div>
          <h1 className="text-2xl md:text-3xl font-black">EPR Certificate Compliance & Fraud Detection</h1>
          <p className="text-slate-300 text-sm max-w-xl">
            Upload processing invoices to cross-examine claimed tonnage against real verified waste picker collection IDs in real time.
          </p>
        </div>

        <button 
          onClick={() => setIsCertificateModalOpen(true)}
          className="px-6 py-3.5 rounded-2xl bg-amber-500 hover:bg-amber-600 text-slate-950 font-black shadow-lg transition-all flex items-center gap-2 hover:scale-105"
          data-testid="open-ai-verify-modal"
        >
          <Sparkles className="w-5 h-5" />
          + Verify New Certificate (AI OCR)
        </button>
      </div>

      {/* Summary Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
        <div className="p-6 rounded-3xl bg-white dark:bg-[#12261A] border border-slate-200 dark:border-emerald-900/30 shadow-sm space-y-2">
          <div className="text-xs font-bold uppercase tracking-wider text-slate-500">Total Certificates Audited</div>
          <div className="text-3xl font-black text-slate-900 dark:text-white">{certificates.length} Files</div>
          <div className="text-xs text-emerald-600 font-medium">Covering ₹45 Cr+ in EPR liabilities</div>
        </div>

        <div className="p-6 rounded-3xl bg-white dark:bg-[#12261A] border border-slate-200 dark:border-emerald-900/30 shadow-sm space-y-2">
          <div className="text-xs font-bold uppercase tracking-wider text-slate-500">Verified Certificates</div>
          <div className="text-3xl font-black text-emerald-600">{certificates.filter(c => c.status === 'Verified').length} Valid</div>
          <div className="text-xs text-slate-500 font-medium">Backed by genuine collection streams</div>
        </div>

        <div className="p-6 rounded-3xl bg-white dark:bg-[#12261A] border border-slate-200 dark:border-emerald-900/30 shadow-sm space-y-2">
          <div className="text-xs font-bold uppercase tracking-wider text-slate-500">Fraud Risk / Flagged</div>
          <div className="text-3xl font-black text-red-600">{certificates.filter(c => c.status.includes('Fraud')).length} Flagged</div>
          <div className="text-xs text-red-500 font-medium">Exceeds physical recycling capacity</div>
        </div>
      </div>

      {/* Certificate Table */}
      <div className="bg-white dark:bg-[#12261A] rounded-3xl p-6 shadow-sm border border-slate-200 dark:border-emerald-900/30 space-y-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div>
            <h3 className="text-xl font-bold text-slate-900 dark:text-white">Recycler Invoices & AI Audit Status</h3>
            <p className="text-xs text-slate-500">Inspecting claimed tonnage vs. verified collection logs.</p>
          </div>

          <div className="relative w-full sm:w-72">
            <Search className="absolute left-3.5 top-3 w-4 h-4 text-slate-400" />
            <input 
              type="text"
              placeholder="Search recycler or brand..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-10 pr-4 py-2 rounded-xl border border-slate-200 dark:border-slate-700 bg-transparent text-sm focus:ring-2 focus:ring-[#1A5C38] outline-none"
              data-testid="search-cert-input"
            />
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="border-b border-slate-200 dark:border-slate-800 text-xs font-bold uppercase text-slate-400">
                <th className="py-3 px-4">Cert ID / Invoice</th>
                <th className="py-3 px-4">Recycler Facility</th>
                <th className="py-3 px-4">Brand Client</th>
                <th className="py-3 px-4">Claimed Tonnage</th>
                <th className="py-3 px-4">AI Verified Tonnage</th>
                <th className="py-3 px-4">Status</th>
                <th className="py-3 px-4">AI Audit Note</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100 dark:divide-slate-800 text-sm">
              {filteredCerts.map((cert, idx) => (
                <tr key={idx} className="hover:bg-slate-50 dark:hover:bg-emerald-950/20 transition">
                  <td className="py-3.5 px-4 font-mono font-bold text-[#1A5C38] dark:text-emerald-400">
                    {cert.id}
                    <div className="text-[11px] text-slate-400 font-normal">{cert.invoiceNo}</div>
                  </td>
                  <td className="py-3.5 px-4 font-semibold text-slate-900 dark:text-white">{cert.recyclerName}</td>
                  <td className="py-3.5 px-4 text-slate-600 dark:text-slate-300">{cert.brandClient}</td>
                  <td className="py-3.5 px-4 font-bold text-slate-900 dark:text-white">{cert.claimedTonnage} t</td>
                  <td className="py-3.5 px-4 font-bold text-emerald-600">{cert.verifiedTonnage} t</td>
                  <td className="py-3.5 px-4">
                    <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-bold ${cert.status === 'Verified' ? 'bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-300 border border-emerald-300' : 'bg-red-100 text-red-700 dark:bg-red-950 dark:text-red-300 border border-red-300'}`}>
                      {cert.status === 'Verified' ? <CheckCircle2 className="w-3.5 h-3.5" /> : <AlertTriangle className="w-3.5 h-3.5" />}
                      {cert.status}
                    </span>
                  </td>
                  <td className="py-3.5 px-4 text-xs text-slate-500 max-w-xs">{cert.note}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

// --- ADMIN / CPCB AUDITOR DASHBOARD ---
function AdminDashboard({ collections, certificates, demoLeads }) {
  const [activeTab, setActiveTab] = useState('overview'); // 'overview', 'fraud', 'search', 'leads'

  const totalTonnage = collections.reduce((acc, curr) => acc + curr.weight, 0);
  const fraudCerts = certificates.filter(c => c.status.includes('Fraud'));
  const verifiedCerts = certificates.filter(c => c.status === 'Verified');

  return (
    <div className="max-w-7xl mx-auto px-6 py-8 space-y-8" data-testid="admin-dashboard">
      {/* Banner */}
      <div className="bg-gradient-to-r from-[#0B1910] via-[#12261A] to-[#1A5C38] rounded-3xl p-6 md:p-8 text-white shadow-xl flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="space-y-2">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-500/20 border border-emerald-500/30 text-emerald-300 text-xs font-semibold">
            <ShieldCheck className="w-3.5 h-3.5 text-amber-400" />
            <span>CPCB & State Pollution Control Board Auditor Console</span>
          </div>
          <h1 className="text-2xl md:text-3xl font-black">National EPR Fraud & Provenance Analytics</h1>
          <p className="text-slate-300 text-sm max-w-xl">
            Real-time oversight of plastic recovery streams across Maharashtra, Gujarat, and Karnataka. Flagging phantom processing and enforcing ₹355 Cr+ penalties.
          </p>
        </div>

        <div className="flex items-center gap-3">
          <button 
            onClick={() => toast.success('National Audit Report PDF downloaded successfully!')}
            className="px-4 py-2.5 rounded-xl bg-white/10 hover:bg-white/25 text-white font-bold text-xs flex items-center gap-2 transition"
            data-testid="export-audit-report-btn"
          >
            <Download className="w-4 h-4" /> Export CPCB Audit PDF
          </button>
        </div>
      </div>

      {/* Navigation Tabs */}
      <div className="flex border-b border-slate-200 dark:border-emerald-900/30 gap-6">
        <button 
          onClick={() => setActiveTab('overview')}
          className={`pb-3 font-bold text-sm border-b-2 transition ${activeTab === 'overview' ? 'border-[#1A5C38] text-[#1A5C38] dark:text-emerald-400' : 'border-transparent text-slate-500 hover:text-slate-900'}`}
          data-testid="tab-overview"
        >
          Regional Analytics & Overview
        </button>
        <button 
          onClick={() => setActiveTab('fraud')}
          className={`pb-3 font-bold text-sm border-b-2 transition flex items-center gap-1.5 ${activeTab === 'fraud' ? 'border-red-600 text-red-600' : 'border-transparent text-slate-500 hover:text-slate-900'}`}
          data-testid="tab-fraud"
        >
          <AlertTriangle className="w-4 h-4" /> Fraud Risk Alerts ({fraudCerts.length})
        </button>
        <button 
          onClick={() => setActiveTab('search')}
          className={`pb-3 font-bold text-sm border-b-2 transition ${activeTab === 'search' ? 'border-[#1A5C38] text-[#1A5C38] dark:text-emerald-400' : 'border-transparent text-slate-500 hover:text-slate-900'}`}
          data-testid="tab-search"
        >
          Collection-to-Certificate Log
        </button>
        <button 
          onClick={() => setActiveTab('leads')}
          className={`pb-3 font-bold text-sm border-b-2 transition ${activeTab === 'leads' ? 'border-[#1A5C38] text-[#1A5C38] dark:text-emerald-400' : 'border-transparent text-slate-500 hover:text-slate-900'}`}
          data-testid="tab-leads"
        >
          Demo Requests ({demoLeads.length})
        </button>
      </div>

      {/* TAB 1: OVERVIEW */}
      {activeTab === 'overview' && (
        <div className="space-y-8 animate-in fade-in duration-200">
          <div className="grid grid-cols-1 sm:grid-cols-4 gap-6">
            <div className="p-6 rounded-3xl bg-white dark:bg-[#12261A] border border-slate-200 dark:border-emerald-900/30 shadow-sm space-y-2">
              <div className="text-xs font-bold uppercase tracking-wider text-slate-500">Real Collection Volume</div>
              <div className="text-3xl font-black text-[#1A5C38] dark:text-emerald-400">{(totalTonnage / 1000).toFixed(1)}k Tonnes</div>
              <div className="text-xs text-emerald-600 font-medium">Backed by verified QR IDs</div>
            </div>

            <div className="p-6 rounded-3xl bg-white dark:bg-[#12261A] border border-slate-200 dark:border-emerald-900/30 shadow-sm space-y-2">
              <div className="text-xs font-bold uppercase tracking-wider text-slate-500">Valid Certificates</div>
              <div className="text-3xl font-black text-slate-900 dark:text-white">{verifiedCerts.length} Verified</div>
              <div className="text-xs text-slate-500 font-medium">Compliant with CPCB norms</div>
            </div>

            <div className="p-6 rounded-3xl bg-white dark:bg-[#12261A] border border-slate-200 dark:border-emerald-900/30 shadow-sm space-y-2">
              <div className="text-xs font-bold uppercase tracking-wider text-slate-500">Fraud Rate Detected</div>
              <div className="text-3xl font-black text-red-600">38.4%</div>
              <div className="text-xs text-red-500 font-medium">Matching CSE 2024 findings</div>
            </div>

            <div className="p-6 rounded-3xl bg-white dark:bg-[#12261A] border border-slate-200 dark:border-emerald-900/30 shadow-sm space-y-2">
              <div className="text-xs font-bold uppercase tracking-wider text-slate-500">Active Safai Sathis</div>
              <div className="text-3xl font-black text-amber-600">1,420 Pickers</div>
              <div className="text-xs text-amber-600 font-medium">Earning direct digital payouts</div>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div className="bg-white dark:bg-[#12261A] rounded-3xl p-6 shadow-sm border border-slate-200 dark:border-emerald-900/30 space-y-4">
              <h3 className="text-lg font-bold text-slate-900 dark:text-white">Regional Compliance Breakdown</h3>
              <p className="text-xs text-slate-500">Percentage of certificates backed by real physical waste collection.</p>
              
              <div className="space-y-4 pt-2">
                <div>
                  <div className="flex justify-between text-sm font-semibold mb-1">
                    <span>Maharashtra (Mumbai, Pune, Nagpur)</span>
                    <span className="text-emerald-600 font-bold">78% Verified</span>
                  </div>
                  <div className="w-full bg-slate-100 dark:bg-slate-800 h-3 rounded-full overflow-hidden">
                    <div className="bg-[#1A5C38] h-full rounded-full" style={{ width: '78%' }} />
                  </div>
                </div>

                <div>
                  <div className="flex justify-between text-sm font-semibold mb-1">
                    <span>Gujarat (Ahmedabad, Surat Godowns)</span>
                    <span className="text-amber-600 font-bold">42% Verified (High Risk)</span>
                  </div>
                  <div className="w-full bg-slate-100 dark:bg-slate-800 h-3 rounded-full overflow-hidden">
                    <div className="bg-amber-500 h-full rounded-full" style={{ width: '42%' }} />
                  </div>
                </div>

                <div>
                  <div className="flex justify-between text-sm font-semibold mb-1">
                    <span>Karnataka (Bengaluru Urban)</span>
                    <span className="text-emerald-600 font-bold">84% Verified</span>
                  </div>
                  <div className="w-full bg-slate-100 dark:bg-slate-800 h-3 rounded-full overflow-hidden">
                    <div className="bg-[#1A5C38] h-full rounded-full" style={{ width: '84%' }} />
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white dark:bg-[#12261A] rounded-3xl p-6 shadow-sm border border-slate-200 dark:border-emerald-900/30 space-y-4">
              <h3 className="text-lg font-bold text-slate-900 dark:text-white">Recent Flagged Audits</h3>
              <p className="text-xs text-slate-500">Recyclers flagged by ReusePlast AI Engine for over-issuance.</p>

              <div className="space-y-3">
                {fraudCerts.map((fc, idx) => (
                  <div key={idx} className="p-3.5 rounded-2xl bg-red-50 dark:bg-red-950/20 border border-red-200 dark:border-red-900/40 flex items-center justify-between text-sm">
                    <div>
                      <div className="font-bold text-red-900 dark:text-red-300 text-xs">{fc.recyclerName}</div>
                      <div className="text-slate-600 dark:text-slate-400 text-[11px]">{fc.brandClient} • Claimed: {fc.claimedTonnage}t</div>
                    </div>
                    <span className="px-2.5 py-1 rounded-lg bg-red-600 text-white text-xs font-bold">
                      {fc.discrepancy} Gap
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* TAB 2: FRAUD ALERTS */}
      {activeTab === 'fraud' && (
        <div className="space-y-6 animate-in fade-in duration-200">
          <div className="bg-white dark:bg-[#12261A] rounded-3xl p-6 shadow-sm border border-slate-200 dark:border-emerald-900/30 space-y-6">
            <div>
              <h3 className="text-xl font-bold text-slate-900 dark:text-white">Flagged Certificates & Phantom Tonnage</h3>
              <p className="text-xs text-slate-500">Recyclers whose claimed recycling tonnage exceeds matching physical collection events.</p>
            </div>

            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="border-b border-slate-200 dark:border-slate-800 text-xs font-bold uppercase text-slate-400">
                    <th className="py-3 px-4">Certificate ID</th>
                    <th className="py-3 px-4">Recycler</th>
                    <th className="py-3 px-4">Brand Client</th>
                    <th className="py-3 px-4">Claimed Tonnage</th>
                    <th className="py-3 px-4">Real Verified</th>
                    <th className="py-3 px-4">Discrepancy</th>
                    <th className="py-3 px-4">Action</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100 dark:divide-slate-800 text-sm">
                  {fraudCerts.map((cert, idx) => (
                    <tr key={idx} className="hover:bg-red-50/50 transition">
                      <td className="py-3.5 px-4 font-mono font-bold text-red-600">{cert.id}</td>
                      <td className="py-3.5 px-4 font-semibold text-slate-900 dark:text-white">{cert.recyclerName}</td>
                      <td className="py-3.5 px-4 text-slate-600 dark:text-slate-300">{cert.brandClient}</td>
                      <td className="py-3.5 px-4 font-bold text-slate-900 dark:text-white">{cert.claimedTonnage} t</td>
                      <td className="py-3.5 px-4 font-bold text-emerald-600">{cert.verifiedTonnage} t</td>
                      <td className="py-3.5 px-4 font-bold text-red-600">{cert.discrepancy}</td>
                      <td className="py-3.5 px-4">
                        <button 
                          onClick={() => toast.error(`CPCB Penalty Notice generated for ${cert.recyclerName}`)}
                          className="px-3 py-1.5 rounded-xl bg-red-600 hover:bg-red-700 text-white font-bold text-xs shadow transition"
                          data-testid={`issue-penalty-${cert.id}`}
                        >
                          Issue Penalty Notice
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {/* TAB 3: SEARCHABLE LOG */}
      {activeTab === 'search' && (
        <div className="space-y-6 animate-in fade-in duration-200">
          <div className="bg-white dark:bg-[#12261A] rounded-3xl p-6 shadow-sm border border-slate-200 dark:border-emerald-900/30 space-y-6">
            <div>
              <h3 className="text-xl font-bold text-slate-900 dark:text-white">Complete Collection ID to Certificate Log</h3>
              <p className="text-xs text-slate-500">Every single plastic bag collected by Safai Sathis and its corresponding recycler destination.</p>
            </div>

            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="border-b border-slate-200 dark:border-slate-800 text-xs font-bold uppercase text-slate-400">
                    <th className="py-3 px-4">Collection ID</th>
                    <th className="py-3 px-4">Safai Sathi</th>
                    <th className="py-3 px-4">Location</th>
                    <th className="py-3 px-4">Weight</th>
                    <th className="py-3 px-4">Recycler Destination</th>
                    <th className="py-3 px-4">Date</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100 dark:divide-slate-800 text-sm">
                  {collections.map((col, idx) => (
                    <tr key={idx} className="hover:bg-slate-50 dark:hover:bg-emerald-950/20 transition">
                      <td className="py-3.5 px-4 font-mono font-bold text-[#1A5C38] dark:text-emerald-400">{col.id}</td>
                      <td className="py-3.5 px-4 font-semibold text-slate-900 dark:text-white">{col.pickerName}</td>
                      <td className="py-3.5 px-4 text-slate-600 dark:text-slate-300">{col.village}</td>
                      <td className="py-3.5 px-4 font-bold text-slate-900 dark:text-white">{col.weight} kg</td>
                      <td className="py-3.5 px-4 text-slate-600 dark:text-slate-300">{col.recycler}</td>
                      <td className="py-3.5 px-4 text-slate-500 text-xs">{col.date}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {/* TAB 4: DEMO LEADS */}
      {activeTab === 'leads' && (
        <div className="space-y-6 animate-in fade-in duration-200">
          <div className="bg-white dark:bg-[#12261A] rounded-3xl p-6 shadow-sm border border-slate-200 dark:border-emerald-900/30 space-y-6">
            <div>
              <h3 className="text-xl font-bold text-slate-900 dark:text-white">Saved Request a Demo List</h3>
              <p className="text-xs text-slate-500">Brand owners and regulators who have requested ReusePlast integration.</p>
            </div>

            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="border-b border-slate-200 dark:border-slate-800 text-xs font-bold uppercase text-slate-400">
                    <th className="py-3 px-4">Name</th>
                    <th className="py-3 px-4">Work Email</th>
                    <th className="py-3 px-4">Company / Organization</th>
                    <th className="py-3 px-4">Request Date</th>
                    <th className="py-3 px-4 text-right">Status</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100 dark:divide-slate-800 text-sm">
                  {demoLeads.map((lead, idx) => (
                    <tr key={idx} className="hover:bg-slate-50 dark:hover:bg-emerald-950/20 transition">
                      <td className="py-3.5 px-4 font-semibold text-slate-900 dark:text-white">{lead.name}</td>
                      <td className="py-3.5 px-4 text-slate-600 dark:text-slate-300">{lead.email}</td>
                      <td className="py-3.5 px-4 font-bold text-[#1A5C38] dark:text-emerald-400">{lead.company}</td>
                      <td className="py-3.5 px-4 text-slate-500 text-xs">{lead.date}</td>
                      <td className="py-3.5 px-4 text-right">
                        <span className="px-2.5 py-1 rounded-full text-xs font-bold bg-emerald-100 text-emerald-800">
                          Demo Scheduled
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
